<div class="tw-border-0 tw-border-t tw-border-solid tw-border-bosch-gray-50" (click)="toggle()">
  <div class="tw-cursor-pointer tw-flex">
    @if(title){
    <h2 class="tw-text-bosch-xl">
      {{ title }}
    </h2>
    } @else{
    <ng-content select="[accordion-header]"></ng-content>
    } @if (hasButton) {
    <bosch-ui-button [type]="buttonType.Integrated" class="tw-ml-auto">
      <bosch-ui-icon [name]="icon$ | async" button-icon></bosch-ui-icon>
    </bosch-ui-button>
    }
  </div>
</div>
<div class="{{ (isExpanded$ | async) ? 'tw-block' : 'tw-hidden' }}">
  <ng-content select="[accordion-content]"></ng-content>
</div>
